import * as React from 'react';

const DocPlaceholderSmall = () => (
  <svg width="48" height="60" viewBox="0 0 48 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 6C0 2.68629 2.68629 0 6 0H31.4788C33.0379 0 34.5358 0.606873 35.6552 1.69209L45.3192 11.061C46.4849 12.1911 47.1429 13.7453 47.1429 15.3689V54C47.1429 57.3137 44.4566 60 41.1429 60H6.00001C2.6863 60 0 57.3137 0 54V6Z"
      fill="#C8C8D2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.5171 0.356934C33.4386 0.497537 33.3926 0.662597 33.3926 0.846397L33.3926 12.2368C33.3926 12.7891 33.8403 13.2368 34.3926 13.2368H46.256C46.4248 13.2368 46.5774 13.1983 46.7098 13.1315C46.3994 12.3592 45.9286 11.6521 45.3189 11.061L35.6549 1.69208C35.0392 1.0952 34.309 0.643019 33.5171 0.356934Z"
      fill="#F0F0F5"
    />
    <rect x="6" y="32" width="36" height="4" rx="2" fill="#F0F0F5" />
    <rect x="6" y="38" width="36" height="4" rx="2" fill="#F0F0F5" />
    <rect x="6" y="44" width="36" height="4" rx="2" fill="#F0F0F5" />
    <rect x="6" y="50" width="36" height="4" rx="2" fill="#F0F0F5" />
    <rect x="14" y="22" width="20" height="4" rx="2" fill="#F0F0F5" />
  </svg>
);

export default DocPlaceholderSmall;
